import { backendInstance } from './base'

const BASE_URL = '/pay'

export type PaymentMethod = {
  id: number
  creationDateTime: Date
  payServiceName: string
  currencyCode: string
  payMethodCode: string
}

// const MOCK_METHODS: PaymentMethod[] = [
//   {
//     id: 1,
//     commissionPercent: 7.5,
//     currency: 'RUB',
//     paymentMethod: 'CARD',
//     paymentMethodDisplayName: 'Card'
//   },
//   {
//     id: 2,
//     commissionPercent: 5.5,
//     currency: 'RUB',
//     paymentMethod: 'QIWI',
//     paymentMethodDisplayName: 'QIWI'
//   },
//   {
//     id: 31,
//     commissionPercent: 1,
//     currency: 'ETH',
//     paymentMethod: 'ARBITRUM',
//     paymentMethodDisplayName: 'Arbitrum'
//   },
//   {
//     id: 35,
//     commissionPercent: 1,
//     currency: 'USDT',
//     paymentMethod: 'ARBITRUM',
//     paymentMethodDisplayName: 'Arbitrum'
//   },
//   {
//     id: 41,
//     commissionPercent: 1,
//     currency: 'USDC',
//     paymentMethod: 'ARBITRUM',
//     paymentMethodDisplayName: 'Arbitrum'
//   },
//   {
//     id: 26,
//     commissionPercent: 1,
//     currency: 'AVAX',
//     paymentMethod: 'AVALANCHE',
//     paymentMethodDisplayName: 'Avalanche'
//   },
//   {
//     id: 32,
//     commissionPercent: 1,
//     currency: 'ETH',
//     paymentMethod: 'AVALANCHE',
//     paymentMethodDisplayName: 'Avalanche'
//   },
//   {
//     id: 36,
//     commissionPercent: 1,
//     currency: 'USDT',
//     paymentMethod: 'AVALANCHE',
//     paymentMethodDisplayName: 'Avalanche'
//   },
//   {
//     id: 42,
//     commissionPercent: 1,
//     currency: 'USDC',
//     paymentMethod: 'AVALANCHE',
//     paymentMethodDisplayName: 'Avalanche'
//   },
//   {
//     id: 28,
//     commissionPercent: 1,
//     currency: 'DAI',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 34,
//     commissionPercent: 1,
//     currency: 'ETH',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 38,
//     commissionPercent: 1,
//     currency: 'USDT',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 44,
//     commissionPercent: 1,
//     currency: 'USDC',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 54,
//     commissionPercent: 1,
//     currency: 'MATIC',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 56,
//     commissionPercent: 1,
//     currency: 'VERSE',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 50,
//     commissionPercent: 2,
//     currency: 'BUSD',
//     paymentMethod: 'ETH',
//     paymentMethodDisplayName: 'Ethereum'
//   },
//   {
//     id: 27,
//     commissionPercent: 1,
//     currency: 'DAI',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 33,
//     commissionPercent: 1,
//     currency: 'ETH',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 37,
//     commissionPercent: 1,
//     currency: 'USDT',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 43,
//     commissionPercent: 1,
//     currency: 'USDC',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 47,
//     commissionPercent: 1,
//     currency: 'CGPT',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 48,
//     commissionPercent: 1,
//     currency: 'BNB',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 49,
//     commissionPercent: 2,
//     currency: 'BUSD',
//     paymentMethod: 'BSC',
//     paymentMethodDisplayName: 'BSC'
//   },
//   {
//     id: 29,
//     commissionPercent: 1,
//     currency: 'DAI',
//     paymentMethod: 'POLYGON',
//     paymentMethodDisplayName: 'Polygon'
//   },
//   {
//     id: 39,
//     commissionPercent: 1,
//     currency: 'USDT',
//     paymentMethod: 'POLYGON',
//     paymentMethodDisplayName: 'Polygon'
//   },
//   {
//     id: 45,
//     commissionPercent: 1,
//     currency: 'USDC',
//     paymentMethod: 'POLYGON',
//     paymentMethodDisplayName: 'Polygon'
//   },
//   {
//     id: 55,
//     commissionPercent: 1,
//     currency: 'MATIC',
//     paymentMethod: 'POLYGON',
//     paymentMethodDisplayName: 'Polygon'
//   },
//   {
//     id: 40,
//     commissionPercent: 1,
//     currency: 'USDT',
//     paymentMethod: 'TRON',
//     paymentMethodDisplayName: 'TRON'
//   },
//   {
//     id: 46,
//     commissionPercent: 1,
//     currency: 'USDC',
//     paymentMethod: 'TRON',
//     paymentMethodDisplayName: 'TRON'
//   },
//   {
//     id: 59,
//     commissionPercent: 1,
//     currency: 'TRX',
//     paymentMethod: 'TRON',
//     paymentMethodDisplayName: 'TRON'
//   },
//   {
//     id: 51,
//     commissionPercent: 2,
//     currency: 'BUSD',
//     paymentMethod: 'TRON',
//     paymentMethodDisplayName: 'TRON'
//   },
//   {
//     id: 25,
//     commissionPercent: 1,
//     currency: 'BTC',
//     paymentMethod: 'BTC',
//     paymentMethodDisplayName: 'BTC'
//   },
//   {
//     id: 30,
//     commissionPercent: 1,
//     currency: 'BCH',
//     paymentMethod: 'BCH',
//     paymentMethodDisplayName: 'BCH'
//   },
//   {
//     id: 52,
//     commissionPercent: 1,
//     currency: 'DASH',
//     paymentMethod: 'DASH',
//     paymentMethodDisplayName: 'DASH'
//   },
//   {
//     id: 53,
//     commissionPercent: 1,
//     currency: 'DOGE',
//     paymentMethod: 'DOGE',
//     paymentMethodDisplayName: 'DOGE'
//   },
//   {
//     id: 57,
//     commissionPercent: 1,
//     currency: 'SOL',
//     paymentMethod: 'SOL',
//     paymentMethodDisplayName: 'SOL'
//   },
//   {
//     id: 58,
//     commissionPercent: 1,
//     currency: 'TON',
//     paymentMethod: 'TON',
//     paymentMethodDisplayName: 'TON'
//   },
//   {
//     id: 60,
//     commissionPercent: 1,
//     currency: 'XMR',
//     paymentMethod: 'XMR',
//     paymentMethodDisplayName: 'XMR'
//   },
//   {
//     id: 61,
//     commissionPercent: 0,
//     currency: 'RUB',
//     paymentMethod: 'DEPOSIT_CODE',
//     paymentMethodDisplayName: 'Код Garantex'
//   },
//   {
//     id: 62,
//     commissionPercent: 0,
//     currency: 'USD',
//     paymentMethod: 'DEPOSIT_CODE',
//     paymentMethodDisplayName: 'Код Garantex'
//   },
//   {
//     id: 63,
//     commissionPercent: 0,
//     currency: 'EUR',
//     paymentMethod: 'DEPOSIT_CODE',
//     paymentMethodDisplayName: 'Код Garantex'
//   },
//   {
//     id: 66,
//     commissionPercent: 5,
//     currency: 'USD',
//     paymentMethod: 'PERFECT_MONEY',
//     paymentMethodDisplayName: 'Perfect Money'
//   },
//   {
//     id: 67,
//     commissionPercent: 5,
//     currency: 'EUR',
//     paymentMethod: 'PERFECT_MONEY',
//     paymentMethodDisplayName: 'Perfect Money'
//   }
// ]

export type PaymentMethodsDTORequest = {
  payServiceName?: string
  currencyCode?: string
  payMethodCode?: string
}
export type PaymentMethodsDTOResponse = PaymentMethod[]

export const getPaymentMethodsCall = async (
  payload: PaymentMethodsDTORequest
): Promise<PaymentMethodsDTOResponse> => {
  try {
    const response = await backendInstance.get(`${BASE_URL}/methods/list`, {
      params: payload
    })
    return response.data
  } catch (err) {
    throw err
  }
}

// #region TOPUP REQUEST
export type PayRequestDTORequest = {
  sumInputCurrencyCode: string
  outerPayMethodType: string
  periodDays: number
}
export type PayRequestDTOResponse = {
  redirectUrl: string
  inputWallet: string
  outerOrderId: string
  targetInputSumValue: number
  webhookHandleUrl: string
  payHistoryId: number
}

export const paymentRequestCall = async (
  payload: PayRequestDTORequest
): Promise<PayRequestDTOResponse> => {
  try {
    const response = await backendInstance.post(
      `${BASE_URL}/cryptomus/create/invoice`,
      {
        sumInputCurrencyCode: payload.sumInputCurrencyCode,
        outerPayMethodType: payload.outerPayMethodType,
        periodDays: payload.periodDays
      }
    )
    return response.data
  } catch (err) {
    throw err
  }
}

// #endregion
